import { makeStyles } from '@material-ui/core';

import { green, neutral, red } from 'shared/styles/colors';

export default makeStyles({
  root: ({ size }: Props) => ({
    height: 'fit-content',
    width: 'fit-content',
    padding: size === 'regular' ? '0.125rem 0.5rem' : '0 0.5rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    borderRadius: '1.25rem',
    color: green[60],
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
    '&[data-status-stockout="true"]': {
      color: red[70],
    },
    '& > [aria-label="icon"]': {
      fontSize: '1rem',
    },
    '& [aria-label="label"]': {
      color: neutral[80],
    },
  }),
});

interface Props {
  size: 'small' | 'regular';
}
